(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define([], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory();
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function () {
  'use strict';

  /**
   * Singleton service for managing local storage
   *
   * @class localStorageService
   * @constructor
   */
  var localStorageService = {
    LOCAL_STORAGE_KEYS: {
      /**
       * @property pdfjsDatabase {String} local storage key name of the database used by pdfjs to cache info about pdfs.
       */
      pdfjsDatabase: 'database',
      /**
       * @property remoteLoggerMessageBacklog {String} local storage key name of where the remote logger backlog is saved.
       */
      remoteLoggerMessageBacklog: 'messageBacklog'
    },

    /**
     * Determines whether or not the session storage is accessible.
     * @method localStorageExists
     * @private
     * @return {Boolean} true if the browser supports local storage, false otherwise.
     */
    localStorageExists: function() {
      // Detection borrowed from: http://diveintohtml5.info/detect.html#storage
      try {
        return 'localStorage' in window && window.localStorage !== null;
      } catch (ex) {
        return false;
      }
    },

    /**
     * Get key from the local storage
     * @method getItem
     * @param keyName {String} the name of the key you want to retrieve the value of.
     * @returns {Object} the key value parsed to object. If the key does not exist, null is returned.
     */
    getItem: function(keyName) {
      if (localStorageService.localStorageExists()) {
        var keyValue = window.localStorage.getItem(keyName);
        if (keyValue !== undefined && keyValue !== null) {
          return JSON.parse(keyValue);
        }
      }
      return null;
    },

    /**
     * Set a key to the local storage.
     * @param keyName {String} the name of the key you want to create or update.
     * @param keyValue {Object} the value of the key you want to create or update.
     * @method setItem
     */
    setItem: function(keyName, keyValue) {
      if (localStorageService.localStorageExists()) {
        window.localStorage.setItem(keyName, JSON.stringify(keyValue));
      }
    },

    /**
     * Remove key from local storage
     * @param keyName {String} the name of the key you want to remove.
     * @method removeItem
     */
    removeItem: function(keyName) {
      if (localStorageService.localStorageExists()) {
        window.localStorage.removeItem(keyName);
      }
    }
  };

  return localStorageService;
}));
